<template type="text/x-template" id="item-template">
  <li style="list-style-type: none; padding: 10">
    <div>
      <div class="row" style="justify-content: space-between">
        <div class="col-sm-9 label">
          <img
            v-if="isFolder"
            :src="
              require(isOpen
                ? '../assets/images/arrowUpIcon.svg'
                : '../assets/images/arrowDownIcon.svg')
            "
            width="12"
            @click="toggle"
          />
          &nbsp; - {{ item.name }}
        </div>
        <div class="col-sm-3 text-right access">
          <input
            type="checkbox"
            v-model="item.access"
            :key="item.id + '_access'"
            @change="onChecked(item, item['access'], 'access')"
            v-bind:id="item.id + '_access_' + item.level"
          />
          &nbsp;
          <input
            type="checkbox"
            v-model="item.alert"
            :key="item.id + '_alert'"
            @change="onChecked(item, item['alert'], 'alert')"
            v-bind:id="item.id + '_alert_' + item.level"
          />
        </div>
      </div>
    </div>
    <ul v-show="isOpen" v-if="isFolder">
      <tree-item
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        :selectedFacility="selectedFacility"
        :selectedSamlGroup="selectedSamlGroup"
      >
      </tree-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeItem",
  props: {
    item: Object,
    selectedFacility: {},
    selectedSamlGroup: {},
  },
  data: function () {
    return {
      isOpen: true,
      globalAccess: true,
      node: {},
    };
  },
  mounted() {
    this.refreshTree();
  },
  computed: {
    isFolder: function () {
      return this.item.children && this.item.children.length;
    },
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    onChecked(node, value, accessType) {
      this.updateChildNodeAccess(node, value, accessType);

      this.refreshTree();
    },
    refreshTree() {
      if (this.selectedFacility) {
        this.selectedFacility.roomAccessCount = 0;
        this.selectedFacility.roomAlertCount = 0;
        if (
          this.selectedFacility.children &&
          this.selectedFacility.children.length > 0
        ) {
          this.selectedFacility.children.forEach((activeFeature) => {
            if (activeFeature.children && activeFeature.children.length > 0) {
              let activeFeatureRoomCount = 0;
              let activeReatureRoomAccessCount = 0;
              let activeReatureRoomAlertCount = 0;
              activeFeature.children.forEach((unit) => {
                if (unit && unit.children && unit.children.length > 0) {
                  unit.children.forEach((area) => {
                    activeFeatureRoomCount++;
                    if (area && area.access) {
                      this.selectedFacility.roomAccessCount++;
                      activeReatureRoomAccessCount++;
                    }
                    if (area && area.alert) {
                      this.selectedFacility.roomAlertCount++;
                      activeReatureRoomAlertCount++;
                    }
                  });
                  if (activeFeatureRoomCount === activeReatureRoomAccessCount)
                    unit.access = true;
                  if (activeFeatureRoomCount === activeReatureRoomAlertCount)
                    unit.alert = true;
                }
              });
              if (activeFeatureRoomCount === activeReatureRoomAccessCount)
                activeFeature.access = true;
              if (activeFeatureRoomCount === activeReatureRoomAlertCount)
                activeFeature.alert = true;
            }
          });
        }
      }
    },
    updateChildNodeAccess(node, value, accessType) {
      if (node.children && node.children.length > 0) {
        node.children.forEach((childNode) => {
          this.updateChildNodeAccess(childNode, value, accessType);
        });
      }
      node["access"] = value;
      if (accessType === "alert") node["alert"] = value;
    },
  },
};
</script>

<style>
.CheckbOXcontainer .checkmark:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 7px;
  border: solid #ebebeb;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}

.checkmark {
  border: 1px solid #ebebeb;
  border-radius: 3px;
}

.tree-group-expansion .tree-group-item > span {
  width: 140px !important;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}

.checkBox label {
  margin: 0;
  position: relative;
  top: -4px;
}

.access-level.checked {
  border-color: #66be6d;
}

label {
  color: #66be6d;
}

.access-level.unchecked label {
  color: "black";
}

.alert-level.checked {
  border-color: #f27778;
}

label {
  color: #3288D2;
}

.access-level.unchecked label {
  color: "black";
}

ul {
  padding-left: 1.5em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>
